import { CALL_HISTORY_METHOD } from 'redux-first-history';
import set from 'lodash/fp/set';

const getUTMs = searchParams => {
  return Array.from(searchParams.entries()).filter(([key]) => key.startsWith('utm_'));
};

const hasUTMs = searchParams => {
  return Array.from(searchParams.entries()).some(([key]) => key.startsWith('utm_'));
};

const getSearchPart = url =>
  // we need to add the origin for handling relative urls cases
  typeof url === 'string' ? new URL(url, window?.location.origin).search : url.search;

const middleware = store => next => action => {
  const state = store.getState();

  // Only apply on url changes
  if (action.type !== CALL_HISTORY_METHOD) {
    return next(action);
  }

  const currentSearchParams = new URLSearchParams(state.router.location.search);
  const nextSearchParams = new URLSearchParams(getSearchPart(action.payload.args[0]));

  const utms = getUTMs(currentSearchParams);
  // We only add utms if they're missing from next url's search params
  if (utms.length !== 0 && !hasUTMs(nextSearchParams)) {
    utms.forEach(utm => {
      nextSearchParams.append(utm[0], utm[1]);
    });

    // args[0] can be either a string or an object representing a location
    if (typeof action.payload.args[0] === 'string') {
      const url = new URL(action.payload.args[0], window?.location.origin);
      const urlWithUTMs = new URL(
        `${url.origin}${url.pathname}?${nextSearchParams.toString()}${url.hash}`
      );
      return next(set('payload.args[0]', urlWithUTMs.toString(), action));
    }
    const searchParamsWithUTMs = nextSearchParams.toString();
    return next(set('payload.args[0].search', searchParamsWithUTMs, action));
  }

  return next(action);
};

export default middleware;
